import { TournamentBracketMatchGameStatus } from '@okletsplay/core';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    '&.MuiChip-root': {
      height: theme.spacing(2),
      fontSize: theme.spacing(1.5),

      '& .MuiChip-label': {
        overflow: 'visible',
      },
    },
  },

  [TournamentBracketMatchGameStatus.Running]: {
    backgroundColor: theme.palette.bracket.status[TournamentBracketMatchGameStatus.Running],
    color: theme.palette.text.primary,

    '&.canceled': {
      backgroundColor: theme.palette.bracket.status[TournamentBracketMatchGameStatus.Locked],
    },
  },

  [TournamentBracketMatchGameStatus.Ready]: {
    backgroundColor: theme.palette.bracket.status[TournamentBracketMatchGameStatus.Ready],
    color: theme.palette.black,

    '&.canceled': {
      backgroundColor: theme.palette.bracket.status[TournamentBracketMatchGameStatus.Locked],
      color: theme.palette.text.primary,
    },
  },

  [TournamentBracketMatchGameStatus.Locked]: {
    backgroundColor: theme.palette.bracket.status[TournamentBracketMatchGameStatus.Locked],
    color: theme.palette.text.primary,

    '&.canceled': {
      backgroundColor: theme.palette.bracket.status[TournamentBracketMatchGameStatus.Locked],
    },
  },

  [TournamentBracketMatchGameStatus.Waiting]: {
    backgroundColor: theme.palette.bracket.status[TournamentBracketMatchGameStatus.Waiting],
    color: theme.palette.text.primary,

    '&.canceled': {
      backgroundColor: theme.palette.bracket.status[TournamentBracketMatchGameStatus.Locked],
    },
  },

  [TournamentBracketMatchGameStatus.Completed]: {
    backgroundColor: theme.palette.bracket.status[TournamentBracketMatchGameStatus.Completed],
    color: theme.palette.black,
  },

  [TournamentBracketMatchGameStatus.Archived]: {
    backgroundColor: theme.palette.bracket.status[TournamentBracketMatchGameStatus.Archived],
    color: theme.palette.black,
  },
}));
